import React from 'react';
import FilterDtm from './FilterDtm';
import './ActiveFilters.scss';

const handleDelete = (FilterDataObj, filtername, childid, props) => {
  const { categoryActions, location, categoryId, handleFilterFunction, filterDrop } = props;
  if (filterDrop === filtername) {
    categoryActions.filterDropdown(false);
  }
  FilterDataObj[filtername].splice(childid, 1);
  if (FilterDataObj[filtername].length === 0) {
    FilterDtm.updateFilterDtm(filtername);
  }
  /* To remove Items from URL. */
  if (FilterDataObj[filtername].length === 0 && Object.keys(FilterDataObj).length === 1) {
    /* To remove last item from stored object and location. */
    delete FilterDataObj[filtername];
    const locationHash = location.hash;
    let loc = '';
    if (locationHash.includes('dir')) {
      loc = locationHash.slice(
        locationHash.lastIndexOf('dir'),
        locationHash.lastIndexOf('true') + 4
      );
    }
    history.pushState('', '', `#${loc}`);
    const temp = {};
    temp.location = location;
    temp.location.hash = `${loc}`;
    temp.counter = 1;
    temp.FilterDataObj = {};
    temp.reset = true;
    categoryActions.modifyData(temp);
    // history.replaceState(`${location.pathname}${location.hash}`, null, location.pathname + `#${location.hash}`);
    categoryActions.loadCatAndFilterData(categoryId, `${loc}`, 0);
  } else {
    const apiData = {};
    Object.keys(FilterDataObj).forEach(data => {
      apiData[`filter_${data}`] = FilterDataObj[data];
    });
    handleFilterFunction(filtername, FilterDataObj[filtername], FilterDataObj, apiData);
    /* To add items in props. */
    categoryActions.addFilterData(FilterDataObj);
  }
};

const resetFilter = props => {
  const { FilterDataObj, location, categoryActions, categoryId } = props;
  window.scrollBy(0, 0);
  categoryActions.filterDropdown(false);
  Object.keys(FilterDataObj).forEach(oldFilterKey => {
    if (oldFilterKey) FilterDtm.updateFilterDtm(oldFilterKey, 'clear all');
  });

  history.pushState('', '', '#');
  const temp = {};
  temp.location = location;
  temp.counter = 1;
  temp.location.hash = '';
  temp.FilterDataObj = {};
  temp.reset = true;
  temp.reload = {};
  temp.reload.data = {};
  temp.reload.reload = false;
  temp.order = 'best_sellers';
  categoryActions.modifyData(temp);
  // history.replaceState(`${location.pathname}${location.hash}`, null, location.pathname + `#${location.hash}`);
  categoryActions.loadCatAndFilterData(categoryId, '', 0);
  window.scrollTo(0, 0);
  if (window.dtm.LenskartRewamp) {
    window.dtm.LenskartRewamp.Listing.click.resetFilters();
  }
};

const displayFilters = props => {
  const {
    FilterDataObj,
    filterData,
    dataLocale: { RESET_FILTERS },
  } = props;
  /* Sort FilterDataObj to display in sorted manner and to remove unnecessory | line from filter text. */
  let sortFilter = null;
  sortFilter = Object.keys(FilterDataObj);
  const sortedFilter = {};
  sortFilter.forEach(data => {
    if (FilterDataObj[data].length === 0) {
      /* To remove unnecessory line ( || Reset Filter ) from filter text. */
      delete FilterDataObj[data];
    } else {
      /* FilterDataObj sorting to display in standard manner. */
      sortedFilter[data] = FilterDataObj[data];
    }
  });

  if (filterData && filterData.result && filterData.result.filters) {
    const filterDataAll = filterData.result.filters;
    return Object.keys(sortedFilter).map((FilterData, index) => {
      return (
        <span key={index}>
          {sortedFilter[FilterData].length > 0
            ? Object.keys(filterDataAll).map((value, index9) => {
                if (filterDataAll[value].id === FilterData) {
                  return (
                    <span key={index9} className="fil_label_head">
                      {' '}
                      &nbsp;
                      <b>
                        {filterDataAll[value].name}
                        &nbsp;:&nbsp;
                      </b>
                    </span>
                  );
                }
                return '';
              })
            : ''}
          {sortedFilter[FilterData].map((data, key) => {
            return (
              <span key={key} className="fil_label_dat">
                {data.childname}
                &nbsp;
                <span
                  className="close_filter"
                  onClick={() => handleDelete(sortedFilter, FilterData, key, props)}
                >
                  x
                </span>
                &nbsp;&nbsp;
              </span>
            );
          })}
          <span>|&nbsp;</span>
          {Object.keys(sortedFilter).length === index + 1 ? (
            <span className="reset" onClick={() => resetFilter(props)}>
              {RESET_FILTERS}
            </span>
          ) : (
            ''
          )}
        </span>
      );
    });
  }
};

const ActiveFilter = props => {
  const { powerUrls, categoryData, listingScrollStopIndex, initialIndex, dataLocale } = props;
  const { SHOWING, RESULTS, OF } = dataLocale;
  const totalProducts = categoryData.result.num_of_products;
  return (
    <div
      className={
        powerUrls.powerUrls && powerUrls.powerUrls.length ? 'activeFilters' : 'activeFilters'
      }
    >
      <div className="show_filters">{displayFilters(props)}</div>
      {Boolean(totalProducts) && (
        <div className="show_count">{`${SHOWING} ${
          totalProducts >= 6 && initialIndex + (listingScrollStopIndex + 1) * 3 < totalProducts
            ? initialIndex + (listingScrollStopIndex + 1) * 3
            : totalProducts
        } ${OF} ${totalProducts} ${RESULTS}`}</div>
      )}
    </div>
  );
};

export default ActiveFilter;
